<template>
  <div>
    <div class="hw_wrap" :class="tenantId == '201' ? 'hgisp':''" v-if="!$route.meta.basicLayout">
      <MainHeader />
      <div class="main_wrap">
        <MainLeft />
        <div class="main_container">
          <div class="main_contents">
            <router-view></router-view>
            <MainFooter v-if="!$route.meta.okrFooter" />
          </div>
        </div>
      </div>
    </div>
    <div class="hw_wrap" :class="tenantId == '201' ? 'hgisp':''" v-if="$route.meta.basicLayout">
      <router-view />
    </div>
    <!-- <modals-container @returnAgreement="returnAgreement"/> -->
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import MainHeader from "@/components/cowork/general/main/MainHeader";
import MainFooter from "@/components/cowork/general/main/MainFooter";
import MainLeft from "@/components/cowork/general/main/MainLeft";
import MainTermsAndPolicy from "@/components/cowork/general/main/modal/MainTermsAndPolicy";
import MainExpireExtension from "@/components/cowork/general/main/modal/MainExpireExtension";
import NotiPopup from "@/components/cowork/general/main/modal/NotiPopup";
import NotiTypePopup from "@/components/cowork/general/main/modal/NotiTypePopup";
import EventBus from "@/js/eventbus/eventBus";

export default {
  data() {
    return {
      path : "",
      expire : true,
      tenantId: localStorage.getItem("tenantId"),
    }
  },
  components : {
    MainHeader,
    MainFooter,
    MainLeft
  },
  // beforeRouteUpdate(to, from, next) {
  //   let privacyAgreeYn = localStorage.getItem("privacyAgreeYn");
  //   if(privacyAgreeYn !== null && privacyAgreeYn !== undefined) {
  //     if(privacyAgreeYn !== "1") {
  //       next(false);
  //       this.path = to.path;
  //       this.type = "UPD";
  //       this.handlePrivacy();
  //     } else {
  //       next();
  //     }
  //   }
  // },
  // beforeRouteEnter(to, from, next) {
  //   let privacyAgreeYn = localStorage.getItem("privacyAgreeYn");
  //   if(privacyAgreeYn !== null && privacyAgreeYn !== undefined) {
  //     if(privacyAgreeYn  !== "1") {
  //       next(vm => {
  //         if(localStorage.getItem("privacyAgreeYn") !== "1") {
  //           vm.path = to.path;
  //           vm.type = "ENTER";
  //           vm.handlePrivacy();
  //         }
  //       });
  //     } else {
  //       next();
  //     }
  //   }
  // },
  computed : {
    ...mapState("introInfo", ["isIntro"]),
    ...mapState("introInfo", ["isExpire"]),
    ...mapState("introInfo", ["isPrivacy"]),
    ...mapState("introInfo", ["isInternalUser"]),
  },
  created() {
    EventBus.$off("showExpire");
    EventBus.$on("showExpire", (payload) => {
      if(!this.expire){
        this.handleExpire();
      }
    });
  },
  mounted() {
    this.isIntroCheck();

    // 중복로그인 관련 소켓 확인 
    this.setSocketConnect({userId:localStorage.getItem("userId")});
  },
  methods : {
    ...mapActions("modals", ["showModal","showDialog"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapMutations("introInfo", ["setIntroInfo"]),
    ...mapMutations("mySocket", ["setSocketConnect","setSocketDisConnect"]),
    /* 인트로 & 개인정보활용동의 & 계정만료 화면 유무 체크 */
    isIntroCheck() {
      let obj = this;
      let reqData = {
          url: "/api/auth/isIntroCheck",
          method: "post",
          params: {}
      };
      obj
      .COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if(res.errorCode !== null) {
          console.log(res.errorCode)
        } else {
          if(res.result !== null) {
            let isIntro = res.result.isIntro;
            obj.expire = res.result.isExpire;
            let isPrivacy = res.result.isPrivacy;
            let isInternalUser = res.result.isInternalUser;
            let isExternalUser = res.result.isExternalUser;

            if(!res.result.isNotiPopup){
              obj.showNotiPopup();
            }

            if(!res.result.isNotiTypePopup){
              obj.showNotiTypePopup();
            }
            // if(isInternalUser) {
            //   isIntro = res.result.isIntro;
            //   isPrivacy = res.result.isPrivacy;
            // } else {
            //   if(isExternalUser) {
            //     isExpire = res.result.isExpire;
            //   } else {
            //     isPrivacy = res.result.isPrivacy;
            //   }
            // }
            obj.setIntroInfo({
              isIntro : isIntro,
              isExpire : obj.expire,
              isPrivacy : isPrivacy,
              isInternalUser : isInternalUser,
              isExternalUser : isExternalUser
            });

            // if(isExpire === false && isPrivacy === false) { /* 계정만료 레이어 노출 후 로그인 화면으로 이동 */
            //   obj.handlePrivacy();
            // } else if(isExpire === false) {  /* 계정만료 레이어 노출 */
            //   obj.handleExpire();
            // } else if(isPrivacy === false) { /* 개인정보활용동의 레이어 노출 */
            //   obj.handlePrivacy();
            // }
            if(isPrivacy === false) { /* 개인정보활용동의 레이어 노출 */
              obj.handlePrivacy();
            }
          }
        }
      })
      .catch(function(err) {
        console.log(err);
      })
    },
    /* 개인정보활용동의 레이어 노출 */
    handlePrivacy() {
      //let privacyAgreeYn = localStorage.getItem("privacyAgreeYn");
      
      if(this.isPrivacy !== null && this.isPrivacy !== undefined) {
        if (!this.isPrivacy) {
          const modalInfo = {
              width: "800px",
              obj: this.$modal,
              urlPath : this.path,
              type : this.type,
              component: MainTermsAndPolicy
          };
          this.showModal(modalInfo);
        }
      }
    },
    /* 계정만료연장 레이어 노출 */
    handleExpire() {
      if(!this.expire) {
        const modalInfo = {
          width: "800px",
          obj: this.$modal,
          urlPath : this.path,
          type : this.type,
          component: MainExpireExtension
        };
        this.showModal(modalInfo);
      }
    },
    /* 알림 팝업  */
    showNotiPopup() {
      const modalInfo = {
        obj: this.$modal,
        // width: "400px",
        component: NotiPopup
      };
      this.showModal(modalInfo);
    },
    /* 알림 팝업  */
    showNotiTypePopup() {
      const modalInfo = {
        obj: this.$modal,
        // width: "400px",
        component: NotiTypePopup
      };
      this.showModal(modalInfo);
    }
  }
};
</script>

<style>
.prevent-emoticon-layer-scroll {
  overflow-y: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/Index.vue